import { createStore } from 'vuex'
import auth from './modules/auth'
import invoice from './modules/invoice'
import users from './modules/users'
import credits from './modules/credits'
import settings from './modules/settings'

export default createStore({
  modules: {
    auth,
    invoice,
    users,
    credits,
    settings
  }
})